import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store';

import IndexView from '../views/indexView/index.view.vue';
import AccessView from '../views/accessView/access.view.vue';
import CheckView from '../views/checkView/check.view.vue';
import AdminView from '../views/adminView/admin.view.vue';
import BookingView from '../views/bookingView/booking.view.vue';
import SignUpView from '../views/signUpView/signup.view.vue';


Vue.use(VueRouter)

const routes: Array<RouteConfig> = [

  { 
    path: '/', 
    redirect: { name: 'IndexView' }
  },
  {
    path: '/index',
    name: 'IndexView',
    component: IndexView
  },
  {
    path: '/index/park/:park',
    name: 'IndexViewPark',
    component: IndexView
  },
  {
    path: '/index/park/:park/clientType/:clientType',
    name: 'IndexViewParkClientType',
    component: IndexView
  },


  {
    path: '/booking',
    name: 'BookingView',
    component: BookingView
  },
  {
    path: '/booking/cc/:cc/park/:park/clientType/:clientType',
    name: 'BookingViewParams',
    component: BookingView
  },
  {
    path: '/access',
    name: 'AccessView',
    component: AccessView
  },
  {
    path: '/check/bookingId/:bookingId',
    name: 'CheckView',
    component: CheckView
  },
  {
    path: '/signup',
    redirect: { name: 'SignUpView', params: { cc: ''} }
  },
  {
    path: '/signup/cc/:cc/park/:park/clientType/:clientType',
    name: 'SignUpView',
    component: SignUpView
  },
  {
    path: '/admin',
    name: 'AdminView',
    component: AdminView
  },
  
  
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if ((
  to.name !== 'IndexView' && 
  to.name !== 'SignUpView') && 
  to.name !== 'AdminView' && 
  to.name !== 'AccessView' &&
  to.name !== 'CheckView'
  ) {

    if((store.state.user) && (store.state.user.name)){
      next()
    } else {
      next({ name: 'IndexView' })
    }
    
  }
  else next()
})


export default router
